var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useMemo } from "react";
import { useAllUsers, useUsers } from "../../../utils/hooks/users/useUsers";
var userId = function (access) { var _a; return (_a = access.user) === null || _a === void 0 ? void 0 : _a.id; };
var userLabel = function (access) {
    var user = access.user;
    return [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName].filter(Boolean).join(" ")
        || (user === null || user === void 0 ? void 0 : user.email)
        || (user === null || user === void 0 ? void 0 : user.id)
        || "-";
};
var FilterUserIdInput = function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? [] : _b, setIds = _a.setIds;
    var allUsersQuery = useAllUsers();
    var selectedUsersQuery = useUsers(ids);
    var options = useMemo(function () {
        var _a, _b;
        var byId = new Map();
        __spreadArray(__spreadArray([], ((_a = allUsersQuery.data) !== null && _a !== void 0 ? _a : []), true), ((_b = selectedUsersQuery.data) !== null && _b !== void 0 ? _b : []), true).forEach(function (access) {
            var id = userId(access);
            if (id)
                byId.set(id, access);
        });
        return Array.from(byId.values());
    }, [allUsersQuery.data, selectedUsersQuery.data]);
    var value = ids
        .map(function (id) { return options.find(function (option) { return userId(option) === id; }); })
        .filter(function (option) { return !!option; });
    return (_jsx(Autocomplete, { id: "user-find", multiple: true, fullWidth: true, options: options, value: value, loading: allUsersQuery.isLoading || selectedUsersQuery.isLoading, isOptionEqualToValue: function (option, selected) { return userId(option) === userId(selected); }, getOptionLabel: userLabel, onChange: function (_, selected) { return setIds(selected
            .map(userId)
            .filter(function (id) { return !!id; })); }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: "small", InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [(allUsersQuery.isLoading || selectedUsersQuery.isLoading)
                            ? _jsx(CircularProgress, { color: "inherit", size: 20 })
                            : null, params.InputProps.endAdornment] })) }) }))); } }));
};
export default FilterUserIdInput;
